import React from "react";
import { Box } from "@mui/material";
import { Typography, Divider } from "@mui/material";
import Badge from "@mui/material/Badge";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

import { shortenAddress } from "../../utils/Helpers";
import { useChainbridge } from "../../contexts/ChainbridgeContext/ChainbridgeContext";
import { ReactComponent as Logo } from "../../media/Icons/logo.svg";
import { ReactComponent as Title } from "../../media/Icons/title.svg";
import { classes } from "./styles";


interface IAppHeader {}

const AppHeader: React.FC<IAppHeader> = () => {
  const theme = useTheme();
  const { homeConfig, isReady, address } = useChainbridge();
  const matches = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box component="header" sx={classes.header}>
      <Box display="flex" alignItems="center" gap={4}>
        <Logo
          height={matches ? "30px" : "auto"}
          width={matches ? "130px" : "173px"}
        />
        <Divider
          orientation="vertical"
          flexItem
          variant="middle"
          sx={{
            borderColor: "#7F9EAF",
          }}
        />
        <Title height={matches ? "16px" : "20px"} />
      </Box>
      <Box>
        {!isReady ? (
          <Typography color={theme.palette.secondary.main} fontWeight={500}>
            No wallet connected
          </Typography>
        ) : (
          <>
            <Box>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="flex-end"
                gap={2}
              >
                {address && <Badge color="secondary" variant="dot" />}
                <Typography
                  color={theme.palette.text.primary}
                  variant="h6"
                  fontSize="16px"
                >
                  {address && shortenAddress(address)}
                </Typography>
              </Box>
              <Box fontSize={16} color={theme.palette.text.primary}>
                <Typography fontWeight={500} variant="body1">
                  connected to {homeConfig?.name}
                </Typography>
              </Box>
            </Box>
          </>
        )}
      </Box>
    </Box>
  );
};

export default AppHeader;
